<template>
  <div class="receptionUnitHome">
    <div class="receptionUnitHome_body">
      <router-view></router-view>
    </div>

    <div class="receptionUnitHome_foot">
      <div v-for="(item,index) in list" :key="index" :class="[active == index ?'active':'notActive']"
           @click="routerJump(index,item)">
        <img class="active_not_select" :src="item.img" alt=""/>
        <img class="active_select" :src="item.selectImg" alt=""/>
        <p>
          {{ item.title }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      active: 0,
      vde: '',
      list: [
        {
          title: '审核',
          path: '/receptionUnit/audit',
          img: require('@/assets/img/receptionUnit/audit.png'),
          selectImg: require('@/assets/img/receptionUnit/audit1.png')
        },
        {
          title: '缴费',
          path: '/receptionUnit/pay',
          img: require('@/assets/img/receptionUnit/pay.png'),
          selectImg: require('@/assets/img/receptionUnit/pay1.png')
        },
        {
          title: '开票情况',
          path: '/receptionUnit/invoicing',
          img: require('@/assets/img/receptionUnit/invoicing.png'),
          selectImg: require('@/assets/img/receptionUnit/invoicing1.png')
        }, {
          title: '对账单',
          path: '/receptionUnit/accountStatement',
          img: require('@/assets/img/receptionUnit/accountStatement.png'),
          selectImg: require('@/assets/img/receptionUnit/accountStatement1.png')

        }, {
          title: '数据汇总',
          path: '/receptionUnit/dataSummary',
          img: require('@/assets/img/receptionUnit/dataSummary.png'),
          selectImg: require('@/assets/img/receptionUnit/dataSummary1.png')

        },
      ]
    }
  },
  mounted() {
    this.vde = this.$route.query.vde
    let path = this.$route.path
    if (path === '/receptionUnit/audit') this.active = 0
    if (path === '/receptionUnit/pay') this.active = 1
    if (path === '/receptionUnit/invoicing') this.active = 2
    if (path === '/receptionUnit/accountStatement') this.active = 3
    if (path === '/receptionUnit/dataSummary') this.active = 4
  },
  methods: {
    routerJump(index, item) {
      this.active = index
      if (this.$route.path != item.path) {
        this.$router.push({
          path: `${item.path}?vde=${this.vde}`,
        });
      }

    }
  }
}
</script>

<style scoped lang="scss">
.receptionUnitHome {
  height: 100vh;

  .receptionUnitHome_body {
    height: calc(100% - 49px);
    //background: red;
  }

  .receptionUnitHome_foot {
    position: absolute;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 49px;
    background: #fff;
    bottom: 0;
    box-shadow: inset 0px 1px 0px 0px rgba(238,238,238,1);
    > div {
      width: 25%;
      text-align: center;
      padding-top: 6px;

      img {
        height: 20px;
      }

      p {

        font-size: 11px;
        color: #464A4C;
        letter-spacing: 0;
        font-weight: 400;
        margin-top: 3px;
      }
    }

    .active {
      p {
        color: #208fff !important;
      }

      .active_not_select {
        display: none !important;
      }

      .active_select {
        display: inline-block !important;
      }

    }

    .notActive {
      .active_select {
        display: none;
      }
    }

  }
}
</style>
